import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

const AboutLearningModal = ({ openForm, openSpravka }) => {
	const { t, i18n } = useTranslation()
	const [modalData, setModalData] = useState([])
	const [refusal, setRefusal] = useState(false)
	const [isSave, setIsSave] = useState(false)
	const [updateData, setUpdateData] = useState({
		naznachenie: '',
		naznachenie_kg: '',
		surname: '',
		raion_kg: '',
		cause: ''
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const change = e => {
		const { name, value } = e.target
		setUpdateData({ ...updateData, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}

	// const getReports = async id => {
	// 	const a = await http.post('/report/reportApplicationWait?reportType=' + id)
	// 	report.newReport(a.data.reportApplicationWait)
	// }

	const openInput = () => {
		setRefusal(!refusal)
	}

	// React.useEffect(() => {
	// 	getReports(0)
	// }, [])
	React.useEffect(() => {
		if (openForm) {
			getModaldata()
		}
	}, [])

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
			// naznachenie: student.student.naznachenie,
		})
		setModalData(res.data.data)
		setUpdateData({
			naznachenie: res.data.data.naznachenie,
			naznachenie_kg: res.data.data.naznachenie_kg,
			raion_kg: res.data.data.raion_kg,
			cause: res.data.data.cause
		})

		// console.log("modal", modalData);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])

	const updateModalDate = async () => {
		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			naznachenie: updateData.naznachenie,
			naznachenie_kg: updateData.naznachenie_kg,
			surname: updateData.surname,
			raion_kg: updateData.raion_kg,
			practice: false,
			cause: updateData.cause,
			data_c: null,
			data_po: null,
			data_c_os: null,
			data_po_os: null,
			data_c_vs: null,
			data_po_vs: null,
			data_c_prictice: null,
			data_po_practice: null,
			data_c_holidays: null,
			data_po_holidays: null,
			work: null
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			setIsSave(false)
		}
		// console.log("update", res);
	}

	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			// getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData?.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateData.naznachenie?.length > 5 ? (
								<button className={styles.button_modal}>
									{/* Справка Обходной лист */}

									{student.student.id_okno_document === 1 ? (
										<a
											className='new_report'
											target='_blank'
											href={`/bt/api/r/o-l?idzakaz=${student.student.id_okno_zakaz}&gid=${student.student.id_group}&id=${student.student.id_student}&lang=${i18n.language}`}
											onClick={openForm}
										>
											Просмотр
										</a>
									) : null}

									{/* Справка Военкомат */}

									{student.student.id_okno_document === 2 ? (
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r/v-m?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&idzakaz=${student.student.id_okno_zakaz}&lang=${i18n.language}`}
										>
											{' '}
											Просмотр
										</a>
									) : null}

									{/* Справка об обучении */}

									{student.student.id_okno_document === 4 ? (
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r/s-g?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&idzakaz=${student.student.id_okno_zakaz}&lang=${i18n.language}`}
										>
											{' '}
											Просмотр
										</a>
									) : null}

									{/* Транскрипт */}
									{student.student.id_okno_document === 6 ? (
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r/t-t?idzakaz=${student.student.id_okno_zakaz}&gid=${student.student.id_group}&id=${student.student.id_student}&lang=${i18n.language}`}
											rel='noreferrer'
										>
											Просмотр
										</a>
									) : null}

									{/* Академическая справка */}

									{student.student.id_okno_document === 7 ? (
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/academ?id=${student.student.id_student}&gid=${student.student.id_group}&lang=${i18n.language}`}
										>
											{' '}
											Просмотр
										</a>
									) : null}

									{/* Временное свидетельство */}

									{/* {student.student.id_okno_document === 11 ? (
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r/timely?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
										>
											Просмотр
										</a>
									) : null} */}
								</button>
							) : null}
						</div>
					) : (
						<div></div>
					)}
				</div>

				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData?.reference_number}</p>
							</div>
						</div>

						{/* Инпуты для военкомата  */}
						{student.student.id_okno_document === 2 ? (
							<div className={styles.modal_window_data}>
								<div className={styles.input_block}>
									<span className={styles.name_student_text}>Район (на русском):</span>
									<input
										className={styles.input_modal}
										type='text'
										name='naznachenie'
										value={updateData.naznachenie}
										onChange={change}
									>
										{/* поля район для военкомата */}
									</input>
								</div>
								<div className={styles.input_block}>
									<span className={styles.name_student_text}>Район (кыргызча):</span>
									<input
										className={styles.input_modal}
										type='text'
										name='raion_kg'
										value={updateData.raion_kg}
										onChange={change}
									>
										{/* поля район для военкомата */}
									</input>
								</div>
							</div>
						) : student.student.id_okno_document === 4 ? (
							//  Инпуты окно  для справка об обучении
							<div className={styles.modal_window_data}>
								<div className={styles.input_block}>
									<span className={styles.name_student_text}>Максаты:</span>
									<input
										className={styles.input_modal}
										type='text'
										name='naznachenie_kg'
										value={updateData.naznachenie_kg}
										onChange={change}
									>
										{/* Назначение */}
									</input>
								</div>
								<div className={styles.input_block}>
									<span className={styles.name_student_text}>Назначение:</span>
									<input
										className={styles.input_modal}
										type='text'
										name='naznachenie'
										value={updateData.naznachenie}
										onChange={change}
									>
										{/* Назначение */}
									</input>
								</div>
							</div>
						) : (
							<div className={styles.modal_window_data}>
								<div className={styles.input_block}>
									<span className={styles.name_student_text}>Назначение:</span>
									<input
										className={styles.input_modal}
										type='text'
										name='naznachenie'
										value={updateData.naznachenie}
										onChange={change}
									>
										{/* Назначение */}
									</input>
								</div>
							</div>
						)}

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData?.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Причина отказа:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='rejected_komment'
									placeholder='Введите причину отказа...'
									value={reasonRefusal.rejected_komment}
									onChange={changeRefusal}
								>
									{/* Причина отказа */}
								</input>
							</div>
						</div>
					</div>
				)}
				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 6 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateData.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutLearningModal
